import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  inject,
  OnInit,
  QueryList,
  Renderer2,
  ViewChild,
  ViewChildren,
  ViewEncapsulation,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { SharedModule } from '../../../../shared/shared.module';
import { BaseComponent } from '../../../../../common/components/base.component';
import { ActivatedRoute, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { frontendSettingsSelector } from '../../../../shared/ngrx.stores/frontend.settings/selectors';
import * as FrontendSettingsActions from '../../../../shared/ngrx.stores/frontend.settings/actions';
import {
  IAppState,
  IFrontendSettings,
} from '../../../../shared/ngrx.stores/frontend.settings/states';
import { catchError, delay, distinctUntilChanged, EMPTY, Observable, of, takeUntil } from 'rxjs';
import { GoogleMapService } from '../../../../shared/services/google.map.service';
import { IMapMarkerWithCustomData } from '../../../../shared/models/place.marker';
import { VisitorPlace } from '../../../../shared/models/visitor.place';
import { VisitorEvent } from '../../../../shared/models/visitor.event';
import { VisitorPlaceService } from '../../../../event-calendar/services/visitor.place.service';
import { CalendarActionCommand } from '../../../../shared/models/calendar.action.command';
import { CalendarSharedModule } from '../../../../shared/calendar.shared.module';
import { GoogleMapComponent } from '../../../../shared/components/google.map/google.map.component';
import { AsyncPipe, CommonModule, NgForOf, NgIf } from '@angular/common';
import { MediaQueryService } from '../../../../../common/services/media.query/media.query.service';
import {
  CreateTripCommand,
  TripAttraction,
  TripPlan,
  UserTrip,
  UserTripModel,
} from '../../../../shared/models/vititor.trip.storage.command';
import { SocialLoginComponent } from '../../../../shared/components/social.login/social.login.component';
import { VisitorService } from '../../../../shared/services/visitor.service';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatMenuTrigger } from '@angular/material/menu';
import { ButtonTriggerEvent } from '../../../../../common/components/button/button.component';
import { EventTimeService } from '../../../../event-calendar/services/event.time.service';
import { clone, isDeepEqual, isEmptyArray } from '../../../../../common/utils/object.extensions';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { CreateEditPlanComponent } from '../create.edit.plan/create.edit.plan.component';
import { CdkDrag, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { ConfirmDialogComponent } from '../../../../../common/components/confirm.dialog/confirm.dialog.component';
import { guid } from '../../../../../common/utils/guid';
import { finalize, switchMap, tap } from 'rxjs/operators';
import { FancyEventDetailsModalComponent } from '../../../../event-calendar/components/event.details.modal/fancy.event.details.modal/fancy.event.details.modal.component';
import { IEventDetailsModalData } from '../../../../event-calendar/components/event.details.modal/event.details.modal.provider';
import { FancyPlaceDetailsModalComponent } from '../../../../place-calendar/components/place.details.modal/fancy.place.details.modal/fancy.place.details.modal.component';
import { IPlaceDetailsModalData } from '../../../../place-calendar/components/place.details.modal/place.details.modal.provider';
import { ModalService } from '../../../../../common/services/modal/modal.service';
import { ItineraryComponent } from '../../itinerary/itinerary.component';
import { VisitorEventService } from '../../../../event-calendar/services/visitor.event.service';
import { PlaceStore } from '../../../../place-calendar/ngrx.stores/place.query.command/stores';
import { SeoService } from '../../../../../common/services/seo.service/seo.service';
import { TripDetailsComponent } from '../trip.details/trip.details.component';
import { TripPlannerService } from '../../../services/trip.planner.service';
import { SocketService } from '../../../../shared/services/socket.service';
import { ScriptService } from '../../../../../common/services/load.script/load.script.service';
import { similarity } from '../../../../../common/utils/string.extensions';
import { localStorageKeys } from '../../../../../common/constants/local.storage.keys';
import { eventQueryCommandSelector } from '../../../../event-calendar/ngrx.stores/event.query.command/selectors';
import { SearchAttractionsComponent } from '../../itinerary/search.attractions/search.attractions.component';
import {
  ShareItineraryModalComponent,
  ShareItineraryModalData,
} from '../../common/share.itinerary.modal/share.itinerary.modal.component';
import {
  ExportItineraryPDFCommand,
  ExportPDFService,
  ExportTripPDFCommand,
  PDFType,
} from '../../../../shared/services/export.pdf.service';
import { ProgressSpinnerMode, MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ImageService } from '../../../../../common/services/image/image.service';
import { TripPlanListComponent } from '../trip.plan.list/trip.plan.list.component';
import { CreatePlaceComponent } from 'src/app/modules/place-calendar/components/create.place/create.place.component';
import { CreateEventComponent } from 'src/app/modules/event-calendar/components/create.event/create.event.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DirectionNavigationComponent } from '../../itinerary/direction.navigation/direction.navigation.component';
import { AiBuddyPlaceListingComponent } from 'src/app/modules/place-calendar/components/ai.buddy.place.listing/ai.buddy.place.listing.component';
import { BodyRendererService } from 'src/app/common/services/body.renderer/body.renderer.service';
import { CheckLoginStatusService } from 'src/app/modules/shared/components/social.login/checkLoginStatus.service';

@Component({
  selector: 'ig-trip-planner',
  standalone: true,
  imports: [
    MatIcon,
    SharedModule,
    CalendarSharedModule,
    AsyncPipe,
    NgIf,
    NgForOf,
    FormsModule,
    CommonModule,
    MatTab,
    MatTabGroup,
    CreateEditPlanComponent,
    CdkDrag,
    CdkDropList,
    ConfirmDialogComponent,
    ItineraryComponent,
    ReactiveFormsModule,
    CommonModule,
    SearchAttractionsComponent,
    MatProgressSpinnerModule,
    TripPlanListComponent,
    DirectionNavigationComponent,
    CalendarSharedModule,
  ],
  templateUrl: './trip.planner.component.html',
  styleUrl: './trip.planner.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class TripPlannerComponent extends BaseComponent implements OnInit {
  isMobile = false;
  isShowingMobileLandingPage = true;
  isShowingMapOnMobile = false;
  isShowTripFunctions = false;
  isLg = false;
  isXl = false;
  is2xl = false;
  is3xl = false;
  is4xl = false;
  isLoadingItems = false;
  isLoadingTrips = false;
  isEditMode = false;
  isFoldTripTitle = false;
  isDragging = false;
  isShowPlans = true;
  isShowUnSavedChangesConfirm = false;
  isShowDeleteDayConfirm = false;
  isShowDeleteTripConfirms = [];
  isShowDeleteAttractionConfirms = [];
  isDeletingTrip = false;
  newDay: Date = null;
  editDayText: string = null;
  moveToDate = '';
  isLoading$: Observable<boolean>;
  error$: Observable<string | null>;
  frontendSettings$: Observable<IFrontendSettings | null>;
  isShowingDetails = false;
  selectedPlaceCategoryName = '';
  pdfProgress = 0;
  gridColumnCss = `grid-cols-1 grid-cols-2 grid-cols-3 grid-cols-4`; // specify these tailwind css class so that dynamic css can be applied in html

  isShowGDPR = true;
  isSidebarOpen = true;
  placePage = 1;
  eventPage = 1;
  displayingOn: tripPlannerDisPlayingOn = 'place';
  userEntireTripId: string = null;
  trips: UserTrip[] = null;
  currentTrip: UserTrip = null;
  initTripBeforeEditing: UserTrip = null;
  planForm: FormGroup;
  titleForm: FormGroup;
  selectedType = null;
  dayAttractionLimit = 20;

  mapMarkers: IMapMarkerWithCustomData<VisitorPlace | VisitorEvent>[] = [];
  selectedItemId: string = null;
  useMapMarkerCluster = true;
  directionResults: google.maps.DirectionsResult;

  actionCommand: CalendarActionCommand = new CalendarActionCommand();
  places: VisitorPlace[] = [];
  events: VisitorEvent[] = [];
  placesByPage: { page: number; places: VisitorPlace[] }[] = [];
  eventsByPage: { page: number; events: VisitorEvent[] }[] = [];
  pageSize = 16;
  placeSearchControl: FormControl = new FormControl('');
  eventSearchControl: FormControl = new FormControl('');

  streamWordCount = 0;
  aiResTextContent = '';
  AIGeneratedTrip: {
    answer: string;
    placeStatus: {
      placesMentioned: [];
      placeSearch: [];
    };
  };
  isAIThinking = false;
  isAIGenerateCompleted = false;
  placesForAITripMatching: VisitorPlace[] = [];
  @ViewChild('tripSection', { static: false }) tripSection: ElementRef;
  @ViewChild('createTripBtn', { static: false }) createTripBtn: ElementRef;
  @ViewChild('noTripTip', { static: false }) noTripTip: ElementRef;
  @ViewChild('aiTripContainer', { static: false }) aiTripContainer: ElementRef;
  @ViewChild('aiTripContentContainer', { static: false })
  aiTripContentContainer: ElementRef;
  @ViewChildren('userTrips') userTripEles: QueryList<ElementRef>;

  // defaultTripImg = 'https://img2.baidu.com/it/u=506224651,2404507398&fm=253&fmt=auto?w=940&h=626';
  defaultTripImg =
    'https://iti-images.s3.amazonaws.com/events/d4c6e9dd-29b3-f658-edfd-039ab1e019c5.webp';
  defaultBannerImage = 'https://iti-images.s3.us-east-1.amazonaws.com/imgs/mobile-banner.jpg';
  defaultEventImage = 'https://iti-images.s3.us-east-1.amazonaws.com/imgs/mobile-event.jpg';
  defaultPlaceImage = 'https://iti-images.s3.us-east-1.amazonaws.com/imgs/mobile-place.jpg';
  defaultItineraryImage = 'https://iti-images.s3.us-east-1.amazonaws.com/imgs/mobile-itinerary.jpg';
  defaultTripImage = 'https://iti-images.s3.us-east-1.amazonaws.com/imgs/mobile-trip.jpg';

  @ViewChild(GoogleMapComponent, { static: false })
  googleMap: GoogleMapComponent;
  @ViewChild('daysTabGroup', { static: false }) daysTabGroup: MatTabGroup;
  @ViewChild('createTripLogin', { static: false })
  createTripLogin: SocialLoginComponent;
  @ViewChild('tripTitle', { static: false }) tripTitle: ElementRef;
  @ViewChild('tripContainer', { static: false }) tripContainer: ElementRef;
  @ViewChild(DirectionNavigationComponent, { static: false })
  directionNavigation: DirectionNavigationComponent;
  @ViewChild('aiTripMenuTrigger', { static: false })
  aiTripMenuTrigger: MatMenuTrigger;

  pdfBannerImages: string[] = [];

  snackBar = inject(MatSnackBar);
  renderService = inject(BodyRendererService);

  isShowGPSConfirm = false;
  isNavigationShowing = false;

  constructor(
    public activatedRoute: ActivatedRoute,
    public mediaQueryService: MediaQueryService,
    public visitorService: VisitorService,
    public visitorPlaceService: VisitorPlaceService,
    public visitorEventService: VisitorEventService,
    public socketService: SocketService,
    public googleMapService: GoogleMapService,
    public timeService: EventTimeService,
    public seoService: SeoService,
    public scriptService: ScriptService,
    public renderer: Renderer2,
    public pdfService: ExportPDFService,
    public imageService: ImageService,
    public modalService: ModalService,
    public tripService: TripPlannerService,
    public cdRef: ChangeDetectorRef,
    private checkLoginStatus : CheckLoginStatusService,
    private _router: Router,
    private _fb: FormBuilder,
    private _store: Store<IAppState>
  ) {
    super({ activatedRoute });

    this.mediaQueryService.isMobile$.pipe(takeUntil(this.isDestroyed)).subscribe((isMobile) => {
      this.isMobile = isMobile;
    });
    this.mediaQueryService.isDesktop4Xl$.pipe(takeUntil(this.isDestroyed)).subscribe((is4xl) => {
      this.is4xl = is4xl;
    });
    this.mediaQueryService.isDesktop3Xl$.pipe(takeUntil(this.isDestroyed)).subscribe((is3xl) => {
      this.is3xl = is3xl;
    });
    this.mediaQueryService.isDesktop2Xl$.pipe(takeUntil(this.isDestroyed)).subscribe((is2xl) => {
      this.is2xl = is2xl;
    });
    this.mediaQueryService.isDesktopXl$.pipe(takeUntil(this.isDestroyed)).subscribe((isXl) => {
      this.isXl = isXl;
    });
    this.mediaQueryService.isDesktopLg$.pipe(takeUntil(this.isDestroyed)).subscribe((isLg) => {
      this.isLg = isLg;
    });

    this.planForm = this._fb.group({
      time: [null, []],
      content: [null, []],
      type: [null, []],
      title: [null, []],
    });
    this.titleForm = this._fb.group({
      title: [null, []],
      note: [null, []],
    });

    this.frontendSettings$ = this._store.pipe(select(frontendSettingsSelector));

    this._store.dispatch(FrontendSettingsActions.getFrontendSettings({ hubName: this.hubName }));

    this.frontendSettings$.subscribe((settings: IFrontendSettings) => {
      console.log('this.frontendSettings', this.frontendSettings);
      if (!settings) return;

      if (
        this.frontendSettings.customSettings.tripPlanner.desktopPage.listColumns === 3 &&
        !this.isMobile
      ) {
        this.pageSize = 15;
      }
      if (
        this.frontendSettings.customSettings.tripPlanner.desktopPage.listColumns === 4 &&
        (this.is3xl || this.is4xl)
      ) {
        this.pageSize = 20;
      }

      this.actionCommand.queryCommand.limit = this.pageSize;

      if (settings.toggle.placeCalendar) {
        this.loadPlaces();
      } else {
        this.displayingOn = 'trip';
      }

      if (this.isShowTravelBuddy()) {
        this.renderService.appendToBody(AiBuddyPlaceListingComponent);
      }
    });

    PlaceStore.customDefaultCategoryStore.pipe(takeUntil(this.isDestroyed)).subscribe((cmd) => {
      console.log('cmd from custom category', cmd);
      // when isShowingDetails, the nearby place component in the fancy place details modal will trigger this, we need to ignore it
      if (!cmd || this.isShowingDetails) return;

      this.placePage = 1;
      this.actionCommand.isEventCalendar = false;
      this.actionCommand.queryCommand.page = this.placePage;
      this.actionCommand.queryCommand.category = cmd.category;
      this.actionCommand.queryCommand.categoryList = cmd.categoryList;

      // nearby places component in the fancy place details modal will also trigger the custom default category's title change, which will remove the trip planner's custom default category title
      // so we need to remember and set the custom default category title after the modal closed. Need to refactor this part
      this.selectedPlaceCategoryName = cmd.categoryName;

      this.isLoadingItems = true;
      this.placesByPage = [];
      this.loadPlaces();
    });

    this.setSearchItems('place');
    this.setSearchItems('event');

    if (window.location.href.includes('ig-user-trip=')) {
      const url = new URL(window.location.href);
      const userTrip = url.searchParams.get('ig-user-trip');
      if (userTrip) {
        // switch to itinerary tab in order not to load Google map again, otherwise there will be script errors
        this.displayingOn = 'itinerary';
        const entireTripId = userTrip.split('-').first();
        const singleTripId = userTrip.split('-').last();
        this.modalService.show({
          component: TripDetailsComponent,
          panelClass: [
            this.isMobile ? 'ig-modal-w-90p' : 'ig-modal-w-80p',
            'h-[90vh]',
            'ig-trip-share-modal',
          ],
          data: {
            hubName: this.hubName,
            entireTripId,
            singleTripId,
          },
        });
      }
    }

    this.loadMarkDownScript();
    this.loadPlacesAndEventsForAITrip();
  }

  // testCommunicateWithApp() {
  //   setTimeout(() => {
  //     console.log('Register postMessage in TP');
  //     window.addEventListener('message', (msg) => {
  //       console.log('postMessage in TP: ', msg);
  //       const data = msg.data;
  //       const origin = msg.origin;
  //       const type = msg.type;
  //       const body = {
  //         hubName: this.hubName,
  //         source: 'trip-planner: ' + origin,
  //         level: 'info',
  //         message: JSON.stringify(data) + ' - type: ' + type,
  //         exception: '',
  //         note: 'test communicate with app',
  //         createdAt: Date,
  //       };
  //       this.visitorService.logToDB(body).subscribe((res) => {});
  //     });
  //   });
  // }

  ngOnInit(): void {
    this.isMobile && (this.isSidebarOpen = false);
    localStorage.getItem(localStorageKeys.isGDPRShowed) === 'true'
      ? (this.isShowGDPR = false)
      : (this.isShowGDPR = true);

    // this.testCommunicateWithApp();
  }

  setSearchItems(type: 'event' | 'place' = 'place') {
    (type === 'event' ? this.eventSearchControl : this.placeSearchControl).valueChanges
      .pipe(
        distinctUntilChanged(),
        switchMap((text) => {
          if (text === '') {
            return of(text);
          } else {
            return of(text).pipe(delay(1600));
          }
        })
        // debounceTime(1600),
      )
      .subscribe((value) => {
        this.actionCommand.queryCommand.search = value;
        if (type === 'place') {
          this.actionCommand.isEventCalendar = false;
          this.placesByPage = [];
          this.placePage = 1;
          this.loadPlaces();
        }
        if (type === 'event') {
          this.actionCommand.isEventCalendar = true;
          this.eventsByPage = [];
          this.eventPage = 1;
          this.loadEvents();
        }
      });
  }

  filterEventsByDate(command: { from: Date; to: Date }) {
    this.eventsByPage = [];
    this.eventPage = 1;
    this.actionCommand.queryCommand.from = command.from;
    this.actionCommand.queryCommand.to = command.to;
    this.loadEvents();
  }

  favCustomEventSelected($event) {
    this.eventsByPage = [];
    this.eventPage = 1;
    this.isLoadingItems = true;
    this.actionCommand.isEventCalendar = true;
    this.actionCommand.queryCommand.page = this.eventPage;
    if ($event?._id) {
      // fav custom events
      this.actionCommand.queryCommand.favoriteEventBtnId = $event._id.toString();
      this.actionCommand.queryCommand.choice = undefined;
    } else if ($event) {
      // editor's choice events
      this.actionCommand.queryCommand.favoriteEventBtnId = undefined;
      this.actionCommand.queryCommand.choice = true;
    } else {
      // all events or clear filter
      this.actionCommand.queryCommand.favoriteEventBtnId = undefined;
      this.actionCommand.queryCommand.choice = undefined;
    }

    this.loadEvents();
  }

  shareTrip() {
    if (!SocialLoginComponent.isUserLoggedIn) {
      this.snackBar.open('Please login to share your trip.', 'Close', {
        horizontalPosition: 'center',
        verticalPosition: 'bottom',
        panelClass: 'ig-error-snackbar',
      });
      return;
    }

    const showShareModel = () => {
      this.modalService.show({
        component: ShareItineraryModalComponent,
        data: {
          itinerary: this.currentTrip,
          hubName: this.hubName,
          cityName: this.frontendSettings?.ai?.travelBuddy?.cityName || this.hubName,
          isEditMode: false,
          type: 'trip',
          user: {
            profilePicture: SocialLoginComponent.profilePicture,
            userName:
              SocialLoginComponent.userName ||
              `${SocialLoginComponent.socialName.toUpperCase()} user ${SocialLoginComponent.userId.replace(
                '|google',
                ''
              )}`,
          },
        } as ShareItineraryModalData,
      });
    };

    if (this.currentTrip.status === 'local') {
      this.saveTripToDB(this.currentTrip, showShareModel);
      return;
    }

    showShareModel();
  }

  async exportPDF() {
    this.isShowTripFunctions = false;

    let command = new ExportTripPDFCommand();
    command.hubName = this.hubName;
    command.type = PDFType.trip;
    command.trip = this.currentTrip;

    command.progressCallback = (progress) => {
      this.pdfProgress = progress;
    };

    try {
      // for mobile, if Google map is not loaded, we need to load it before exporting. Otherwise, it will not generate the map
      if (this.isMobile) {
        this.googleMapService.loadGoogleMapApi().subscribe(async () => {
          await this.pdfService.exportTripPDF(command);
          this.pdfProgress = 0;
        });
      } else {
        await this.pdfService.exportTripPDF(command);
      }
    } catch (e) {
      alert(e.message);
      console.log(e);
    } finally {
      this.pdfProgress = 0;
    }
  }

  travelMode(trigger: MatMenuTrigger) {
    this.directionNavigation?.exit();
    this.setMapMarkers();
    setTimeout(() => {
      trigger?.closeMenu();
      this.isShowTripFunctions = false;
    }, 500);
  }

  checkHasAttractions() {
    if (this.currentTrip.days[this.daysTabGroup.selectedIndex].attractions.length > 0) {
      this.isShowGPSConfirm = true;
      return;
    }

    this.snackBar.open('Please select at least one attraction', 'Close', {
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: 'ig-error-snackbar',
    });
  }

  gpsDirections() {
    if (this.isMobile) this.showMobileMap(this.daysTabGroup.selectedIndex);
    this.isNavigationShowing = true;
    this.isShowGPSConfirm = false;
    this.isShowTripFunctions = false;

    setTimeout(() => {
      this.directionNavigation.navigateFromUserGPSLocation(this.currentTrip.travelMode);

      // back to trip attraction list
      if (this.isMobile) this.isShowingMapOnMobile = false;
      this.isNavigationShowing = false;
    }, 50);
  }

  directions() {
    if (this.isMobile) this.showMobileMap(this.daysTabGroup.selectedIndex);
    this.isNavigationShowing = true;
    this.isShowGPSConfirm = false;
    this.isShowTripFunctions = false;

    setTimeout(
      () => {
        this.directionNavigation.nextLeg();
      },
      this.isMobile ? 1500 : 100
    );
  }

  showMobileMap(item: number | VisitorPlace | VisitorEvent) {
    this.isShowingMapOnMobile = true;

    // item = number indicates showing map for user trip
    if (typeof item === 'number') {
      // use setTimeout to ait for the map to render
      setTimeout(() => {
        this.setMapMarkers(this.currentTrip.days[item]);
      }, 100);
      return;
    }

    const itemType = item['startTime'] ? 'events' : 'places';
    // load events/places from cache
    const page =
      itemType === 'events'
        ? this.eventsByPage.find((x) => x.page === this.eventPage)
        : this.placesByPage.find((x) => x.page === this.placePage);
    if (page) {
      this[itemType] = page[itemType];
      setTimeout(() => {
        this.setMapMarkersForItems(this[itemType]);
      }, 50);
      setTimeout(() => {
        // this.googleMap?.fitBounds(200);

        // setTimeout(() => {
        //   const zoom = this.googleMap?.googleMap.googleMap.getZoom();
        //   console.log('zoom', zoom);
        //   this.googleMap?.googleMap.googleMap.setZoom(zoom - 2);
        // }, 1000);

        this.clickAttraction(item);
      }, 150);
    }
  }

  getCategoryText(place: VisitorPlace) {
    if (place.categoryText) {
      return place.categoryText;
    }

    if (place.category) {
      return this.visitorPlaceService.getDisplayCategory(place);
    }

    return '';
  }

  loadPlaces() {
    const page = this.placesByPage.find((x) => x.page === this.placePage);
    if (page) {
      this.places = page.places;

      setTimeout(() => {
        this.setMapMarkersForItems(this.places);
      }, 300);
      setTimeout(() => {
        this.googleMap?.fitBounds();
      }, 1000);
      return;
    }

    this.isLoadingItems = true;
    this.actionCommand.isEventCalendar = false;
    this.actionCommand.queryCommand.page = this.placePage;

    this.visitorPlaceService
      .getPlaces(this.hubName, this.actionCommand.queryCommand)
      .pipe(finalize(() => (this.isLoadingItems = false)))
      .subscribe((places) => {
        this.places = places;

        for (const place of places) {
          const customCategories = this.visitorPlaceService.getPlaceCustomCategories(
            place,
            this.frontendSettings
          );
          place.categoryText = isEmptyArray(customCategories)
            ? place.category
            : customCategories
                .map((x) => x.title)
                .removeDuplicate()
                .join(', ');
        }

        if (!page) {
          this.placesByPage.push({
            page: this.placePage,
            places: places,
          });
        }

        setTimeout(() => {
          this.setMapMarkersForItems(this.places);
        }, 300);
        setTimeout(() => {
          this.googleMap?.fitBounds();
        }, 1000);
      });
  }

  prevPagePlaces() {
    if (this.placePage === 1) {
      return;
    }
    this.placePage--;
    this.loadPlaces();
  }

  nextPagePlaces() {
    if (this.places.length < this.pageSize) {
      return;
    }
    this.placePage++;
    this.loadPlaces();
  }

  loadEvents() {
    const page = this.eventsByPage.find((x) => x.page === this.eventPage);
    if (page) {
      this.events = page.events;
      setTimeout(() => {
        this.setMapMarkersForItems(this.events);
      }, 300);
      setTimeout(() => {
        this.googleMap?.fitBounds();
      }, 1000);
      return;
    }

    this.isLoadingItems = true;
    this.actionCommand.isEventCalendar = true;
    this.actionCommand.queryCommand.page = this.eventPage;

    this.visitorEventService
      .getEvents(this.hubName, this.actionCommand.queryCommand)
      .pipe(finalize(() => (this.isLoadingItems = false)))
      .subscribe((events) => {
        this.events = events;

        if (!page) {
          this.eventsByPage.push({
            page: this.eventPage,
            events,
          });
        }

        setTimeout(() => {
          this.setMapMarkersForItems(this.events);
        }, 300);
        setTimeout(() => {
          this.googleMap?.fitBounds();
        }, 1000);
      });
  }

  prevPageEvents() {
    if (this.eventPage === 1) {
      return;
    }
    this.eventPage--;
    this.loadEvents();
  }

  nextPageEvents() {
    if (this.events.length < this.pageSize) {
      return;
    }
    this.eventPage++;
    this.loadEvents();
  }

  setMapMarkersForItems(items: VisitorPlace[] | VisitorEvent[]) {
    if (!this.googleMap) return;

    this.mapMarkers = [];
    this.googleMap.directionsResults$ = of(null);

    this.mapMarkers = [];
    for (const place of items) {
      this.mapMarkers.push({
        position: {
          lat: place.address.lat,
          lng: place.address.lng,
        },
        options: {
          // icon: {
          //   url: `https://iti-images.s3.amazonaws.com/imgs/map-icon.png`,
          //   scaledSize: new google.maps.Size(40, 55),
          // },
          zIndex: 2,
        },
        title: place._id, // use this for showing map info window when clicking on list items
        data: place,
      } as IMapMarkerWithCustomData<VisitorPlace | VisitorEvent>);
    }
  }

  initLogin() {
    setTimeout(() => {
      this.createTripLogin.initGoogleLogin();
    });
  }

  async loginStatusChanged(status: boolean) {
    // initialize google login again, otherwise only the first google login button can be shown on the page
    // if (!status && this.displayingOn === 'trip') {
    //   setTimeout(() => {
    //     this.createTripLogin.initGoogleLogin();
    //   });
    // }

    this.currentTrip = null;
    this.seoService.removeNameIdForUserTrip();
    await this.loadTrips();
  }

  async addToTripLoginChanged(status: boolean) {
    if (status) {
      await this.loadTrips();
    }
  }

  async goto(target: tripPlannerDisPlayingOn) {
    this.mapMarkers = [];
    
    this.checkLogin();

    if (target === 'trip') {
      if (this.currentTrip) {
        if (this.backToTripList()) {
          this.displayingOn = target;
          await this.loadTrips();
        }
      } else {
        this.displayingOn = target;

        setTimeout(async () => {
          await this.loadTrips();
          // if (!SocialLoginComponent.isUserLoggedIn) {
          //   // initialize google login again, otherwise only the first google login button can be shown on the page
          //   this.createTripLogin.initGoogleLogin();
          // } else {
          //   await this.loadTrips();
          // }
        });
      }
    } else {
      this.seoService.removeNameIdForUserTrip();
    }

    if (target === 'itinerary') {
      this.displayingOn = target;
    }

    if (target === 'place') {
      this.setMapMarkersForItems(this.places);
      this.displayingOn = target;
      this.placePage = 1;
      this.loadPlaces();
    }

    if (target === 'event') {
      this.displayingOn = target;
      this.eventPage = 1;
      this.loadEvents();
    }

    if (this.isMobile) {
      this.isShowingMobileLandingPage = false;
      this.isSidebarOpen = false;
    }
  }

  private checkLogin() : boolean{
    const status = this.checkLoginStatus.checkGoogleLoginStatus() || this.checkLoginStatus.checkFacebookLoginStatus();
    return status;
  }

  async loadTrips() {
    if (this.isLoadingTrips) return;

    if (SocialLoginComponent.isUserLoggedIn) {
      const tripsFromDB = await this.loadUserTripsFromDB();
      const tripsLocal = this.loadLocalTrips();
      this.trips = [...tripsFromDB, ...tripsLocal];
    } else {
      this.trips = this.loadLocalTrips();
    }
    console.log('this.trips', this.trips);

    // google login will not trigger the detect changes
    this.cdRef.detectChanges();
  }

  async loadUserTripsFromDB(): Promise<UserTripModel[]> {
    if (!SocialLoginComponent.userId) return [];

    this.isLoadingTrips = true;
    const trips = await this.tripService.getUserTripsV3(this.hubName, SocialLoginComponent.userId);

    console.log('trips V3', trips);

    this.isLoadingTrips = false;
    this.userEntireTripId = trips._id;
    return trips ? trips.trips || [] : [];
  }

  loadLocalTrips() {
    let trips = [];
    const localTrips = localStorage.getItem('localTrips');
    if (localTrips) {
      trips = JSON.parse(localTrips);
    }
    return trips;
  }

  addTripToLocalTrips(trip: UserTrip) {
    let trips = this.loadLocalTrips();
    trips.push(trip);
    this.trips = trips;
    localStorage.setItem('localTrips', JSON.stringify(this.trips));
  }

  createTrip() {
    if (this.trips.length >= 12) {
      alert(`You have created too many trips.`);
      return;
    }

    const newTrip = {
      id: guid(),
      title: 'New Trip',
      hubName: this.hubName,
      days: [],
      createdAt: new Date().toISOString(),
      userFacebookId: SocialLoginComponent.userId || null,
      travelMode: 'DRIVING',
    } as UserTrip;

    if (!SocialLoginComponent.isUserLoggedIn) {
      try {
        newTrip.status = 'local';
        this.addTripToLocalTrips(newTrip);

        setTimeout(() => {
          const trip = this.userTripEles.toArray().last();
          if (trip) {
            trip.nativeElement.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });

            setTimeout(() => {
              trip.nativeElement.classList.add('outline');
            }, 500);
            setTimeout(() => {
              trip.nativeElement.classList.remove('outline');
            }, 1500);
          }
        });
      } catch (e) {
        console.error('Error saving trip to localStorage', e);
        alert('Failed to save trip. Please try again.');
      }
      return;
    }

    // Existing logic for logged-in users
    const command = {
      id: newTrip.id,
      userFacebookId: SocialLoginComponent.userId,
      newTrip: {
        ...newTrip,
        userFacebookId: SocialLoginComponent.userId,
      },
    } as CreateTripCommand;

    this.visitorService
      .createTrip(this.hubName, command)
      .pipe(takeUntil(this.isDestroyed))
      .subscribe(async () => {
        await this.loadTrips();
        const tripsLocal = this.loadLocalTrips();

        const eleArray = this.userTripEles.toArray();
        const trip = eleArray[eleArray.length - tripsLocal.length - 1];
        if (trip) {
          trip.nativeElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });

          setTimeout(() => {
            trip.nativeElement.classList.add('outline');
          }, 500);
          setTimeout(() => {
            trip.nativeElement.classList.remove('outline');
          }, 1500);
        }
      });
  }

  toggleTripTitle() {
    this.isFoldTripTitle = !this.isFoldTripTitle;
    // if (this.isFoldTripTitle) {
    //   this.tripTitle.nativeElement.style.height = `0`;
    // } else {
    //   this.tripTitle.nativeElement.style.height = `auto`;
    // }
    // this.setTripContainerHeight(10);
  }

  backToTripList() {
    if (this.isEditMode && !isDeepEqual(this.initTripBeforeEditing, this.currentTrip)) {
      this.isShowUnSavedChangesConfirm = true;
      return false;
    }
    this.isEditMode = null;
    this.currentTrip = null;
    this.mapMarkers = [];
    this.seoService.removeNameIdForUserTrip();
    this.resetAITrip();
    return true;
  }

  forceQuitTrip() {
    this.cancelEdit();
    this.seoService.removeNameIdForUserTrip();
    setTimeout(() => {
      this.currentTrip = null;
      this.isShowUnSavedChangesConfirm = false;
    });
  }

  enterTrip(trip: UserTrip) {
    this.currentTrip = trip;

    // auto enter edit mode for new trip
    if (isEmptyArray(this.currentTrip.days)) {
      this.editOrSave(null);
    } else {
      this.setMapMarkers(this.currentTrip.days[0]);
    }

    SocialLoginComponent.isUserLoggedIn && this.setNameIdAndSeo();
    this.setTripContainerHeight();
  }

  setNameIdAndSeo() {
    this.seoService.addNameIdToUrlForUserTrip(
      this.userEntireTripId,
      this.currentTrip,
      this.hubName
    );
  }

  setTripContainerHeight(delay: number = 0) {
    // setTimeout(() => {
    //   const rect = this.tripTitle.nativeElement.getBoundingClientRect();
    //   console.log(rect.height);
    //   // this.tripTitle.nativeElement.style.height = `${rect.height}px`;
    //   this.tripContainer.nativeElement.style.height = `calc(100% - ${rect.height + 25}px`;
    // }, delay);
  }

  getRandomBoolean(place: VisitorPlace) {
    const no = parseInt(place._id);
    return no % 2 === 0;
  }

  showDetails(attraction: TripAttraction | VisitorEvent | VisitorPlace) {
    let modal;

    // has startTime means it is an event
    if (attraction['feedType'] === 'event' || attraction['startTime']) {
      this.isShowingDetails = true;

      modal = this.modalService.show({
        component: FancyEventDetailsModalComponent,
        panelClass: 'ig-modal-w-full',
        data: {
          currentEvent: attraction['item'] || attraction,
          allEvents: [],
          favCustomEvents: [],
          from: 'itinerary',
        } as IEventDetailsModalData,
      });
    } else {
      this.isShowingDetails = true;

      modal = this.modalService.show({
        component: FancyPlaceDetailsModalComponent,
        panelClass: 'ig-modal-w-full',
        data: {
          currentPlace: attraction['item'] || attraction,
          from: 'itinerary',
        } as IPlaceDetailsModalData,
      });
    }

    // nearby places component in the fancy place details modal will also trigger the custom default category's title change, which will remove the trip planner's custom default category title
    // so we need to set the custom default category title after the modal closed. Need to refactor this part
    modal.beforeClosed().subscribe(() => {
      PlaceStore.customDefaultCategoryStore.next({
        categoryName: this.selectedPlaceCategoryName,
        from: 'tripPlanner',
      });
      this.isShowingDetails = false;
    });
  }

  onCloseInfoWindow() {
    // this.useMapMarkerCluster = true;
    // this.setMapMarkersForItems(this.places);
  }

  infoWindowClick($event: VisitorEvent | VisitorPlace) {
    this.isShowingDetails = true;
  }

  onDetailsWindowClose($event: VisitorEvent | VisitorPlace) {
    this.isShowingDetails = false;
  }

  clickAttraction(attraction: TripAttraction | VisitorPlace | VisitorEvent) {
    const _id = attraction['_id'];
    // click on the same attraction card twice, show the details modal
    if (this.selectedItemId === _id) {
      this.showDetails(attraction);
      return;
    }

    if (!this.googleMap) return;

    this.googleMap.closeInfoWindow();
    this.selectedItemId = _id;

    const marker = this.googleMap.mapMarkerObjs.find((x) => x.getTitle() === _id);

    this.googleMap.googleMap.googleMap.setZoom(18);

    this.googleMap.googleMap.googleMap.setCenter(this.createLatLng(attraction));

    setTimeout(
      () => {
        // this.useMapMarkerCluster = false;

        if (attraction['feedType'] === 'event' || attraction['startTime']) {
          this.googleMap.showEventInfoWindow(marker, {
            ...marker,
            data: attraction['item'] || attraction,
          } as IMapMarkerWithCustomData<VisitorEvent>);
        } else {
          this.googleMap.showPlaceInfoWindow(marker, {
            ...marker,
            data: attraction['item'] || attraction,
          } as IMapMarkerWithCustomData<VisitorPlace>);
        }
      },
      this.isMobile ? 1200 : 150
    );
  }

  createLatLng(attraction: TripAttraction | VisitorPlace | VisitorEvent) {
    const item = attraction['item'] || attraction;
    return new google.maps.LatLng(item.lat || item.address.lat, item.lng || item.address.lng);
  }

  markerClick($event, type: 'event' | 'place') {
    if (!$event.data) return;

    type === 'event' && this.googleMap.showEventInfoWindow();
    type === 'place' && this.googleMap.showPlaceInfoWindow();
  }

  setMapMarkers(day?) {
    if (!this.googleMap) return;

    this.mapMarkers = [];
    this.googleMap.directionsResults$ = of(null);

    if (!day) {
      if (!this.currentTrip.days.length) return;
      day = this.currentTrip.days[this.daysTabGroup.selectedIndex];
    }

    this.mapMarkers = [];
    let index = 1;
    let directionLocations: { lat; lng; stopover }[] = [];

    for (const attraction of day.attractions) {
      this.mapMarkers.push({
        position: this.createLatLng(attraction),
        options: {
          icon: {
            url: 'https://imgoingcalendar.com/assets/imgs/tp-marker-2.png',
            anchor: new google.maps.Point(0, 0),
            scaledSize: new google.maps.Size(25, 25),
          } as google.maps.Icon,
          zIndex: 10,
          // optimized: true,
        },
        label: {
          text: (index++).toString(),
          fontWeight: 'bold',
        },
        title: attraction['feedId'] || attraction._id, // use this for showing map info window when clicking on list items, see clickAttraction function
        data: attraction.item,
      } as IMapMarkerWithCustomData<VisitorPlace | VisitorEvent>);

      directionLocations.push({
        lat: attraction.item.address?.lat || attraction.item.lat,
        lng: attraction.item.address?.lng || attraction.item.lng,
        stopover: true,
      });
    }

    console.log('this.mapMarkers', this.mapMarkers);

    if (directionLocations.length) {
      this.googleMap.drawDirectionRoute(
        directionLocations,
        this.currentTrip.travelMode || google.maps.TravelMode.DRIVING
      );

      this.googleMap.directionsResults$.pipe(takeUntil(this.isDestroyed)).subscribe((result) => {
        // only one attraction added
        if (!result) {
          return;
        }

        if (isEmptyArray(result.routes)) {
          this.snackBar.open('Could not load the direction route, please try again.', 'Close', {
            horizontalPosition: 'center',
            verticalPosition: 'bottom',
            panelClass: 'ig-error-snackbar',
          });
          return;
        }

        if (result) {
          this.directionResults = result;
          let totalDistance = 0,
            totalDuration = 0;
          for (const leg of result.routes[0].legs) {
            totalDistance += leg.distance.value;
            totalDuration += leg.duration.value;
          }
          // this.currentItinerary.travelTime = totalDuration;
          // this.currentItinerary.distance = totalDistance;

          // console.log('travelTime', this.currentItinerary.travelTime);
          // console.log('distance', this.currentItinerary.distance);

          // move map to a little right, as left side has the attraction panel
          // setTimeout(() => {
          //   !this.isMobile && this.googleMap.googleMap.googleMap.panBy(-150, 0);
          // }, 20);
        }
        console.log('directionsResults$', result);
      });
    }

    if (directionLocations.length <= 1) {
      this.googleMap.directionsResults$ = of(null);
    }
  }

  loadMarkDownScript() {
    const SCRIPT_PATH = `https://cdn.jsdelivr.net/npm/marked/marked.min.js`;

    if (!this.scriptService.isScriptExist(SCRIPT_PATH)) {
      const scriptElement = this.scriptService.loadJsScript(this.renderer, SCRIPT_PATH);
      scriptElement.onload = () => {
        console.log('markdown script loaded');
      };
      scriptElement.onerror = () => {
        console.log('Could not load the script: ' + SCRIPT_PATH);
      };
    }
  }

  loadPlacesAndEventsForAITrip() {
    this.visitorPlaceService.getDestinationPlaceFeeds(this.hubName).subscribe((places) => {
      this.placesForAITripMatching = places;
      console.log('this.placesForAITrip', this.placesForAITripMatching.length);
    });

    // this.visitorEventService.getDestinationEventFeeds(this.hubName).subscribe((events) => {
    //   this.eventsForAITrip = events;
    //   console.log('events', events.length);
    // });
  }

  isShowTravelBuddy() {
    return (
      this.frontendSettings?.status === 'live' &&
      this.frontendSettings?.ai?.travelBuddy?.isActive &&
      (this.getScriptValue('travel-buddy') === 'true' ||
        this.frontendSettings.ai.travelBuddy.showOnAllClientWidgets ||
        !this.isScriptSolution)
    );
  }

  addAITripToMyTrip(event: ButtonTriggerEvent, trigger: MatMenuTrigger) {
    const places = this.getPlacesFromAIAnswer({
      answer: this.AIGeneratedTrip.answer,
      placesMentioned: this.AIGeneratedTrip.placeStatus.placesMentioned,
      placeSearch: this.AIGeneratedTrip.placeStatus.placeSearch,
    });

    console.log('places in add AI trip', places);

    const saveTrip = (days) => {
      const newTrip = {
        id: guid(),
        title: this.titleForm.get('title').value,
        hubName: this.hubName,
        days,
        createdAt: new Date().toISOString(),
        userFacebookId: SocialLoginComponent.userId || null,
        travelMode: 'DRIVING',
      } as UserTrip;

      if (!SocialLoginComponent.isUserLoggedIn) {
        // Save to localStorage for unauthenticated users
        try {
          newTrip.status = 'local';
          this.addTripToLocalTrips(newTrip);

          setTimeout(() => {
            const trip = this.userTripEles.toArray().last();
            if (trip) {
              trip.nativeElement.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
              });

              setTimeout(() => {
                trip.nativeElement.classList.add('outline');
              }, 500);
              setTimeout(() => {
                trip.nativeElement.classList.remove('outline');
              }, 1500);
            }
          });
        } catch (e) {
          console.error('Error saving trip to localStorage', e);
          alert('Failed to save trip. Please try again.');
        } finally {
          event.complete();
          trigger?.closeMenu();
          this.resetAITrip();
        }
        return;
      }

      this.visitorService
        .createTripV3(this.hubName, {
          singleTrip: newTrip,
          userFacebookId: SocialLoginComponent.userId,
        })
        .pipe(
          takeUntil(this.isDestroyed),
          finalize(() => {
            event.complete();
            trigger?.closeMenu();
            this.resetAITrip();
          })
        )
        .subscribe(async () => {
          await this.loadTrips();
        });
    };

    this.visitorService
      .sendAIQuery(
        this.hubName,
        'extract-trip-keywords',
        'chatgpt',
        this.AIGeneratedTrip.answer,
        []
      )
      .pipe(
        catchError((error) => {
          console.error(error);
          return of({
            success: false,
          });
        })
      )
      .subscribe(async (data) => {
        if (!data.success) {
          console.log(data);

          let index = 0;
          let attractions = [];
          for (const place of places) {
            attractions.push({
              feedType: 'place',
              feedId: place._id,
              order: index++,
              searchedItem: place.hubName ? null : place, // place in the database has hubName, but searched from Google has not. For searched places, we save them in the trip collection in db (we only same place _id for those already in db)
              prePlans: [],
              postPlans: [],
            });
          }

          // saveTrip(attractions);
          return;
        }

        if (data.success) {
          const json = JSON.parse(data.data);
          console.log(json);
          let days = [];

          for (const day of Object.keys(json.itinerary)) {
            if (!day || !day.startsWith('day')) continue;

            let prePlans = [];
            let index = 0;
            let currentDay = {
              date: this.newDay,
              dateText: this.editDayText,
              note: '',
              attractions: [],
            };

            for (const placeFromAI of json.itinerary[day]) {
              let placeInAnswer = places.find(
                (place) =>
                  place.name
                    .replace(/[^a-zA-Z0-9\s]/g, '')
                    .toLowerCase()
                    .includes(placeFromAI.place.replace(/[^a-zA-Z0-9\s]/g, '').toLowerCase()) ||
                  placeFromAI.place
                    .replace(/[^a-zA-Z0-9\s]/g, '')
                    .toLowerCase()
                    .includes(place.name.replace(/[^a-zA-Z0-9\s]/g, '').toLowerCase())
              );

              if (!placeInAnswer) {
                console.log('---- place not found in answer', placeFromAI.place);
                const placeSearched = await this.visitorPlaceService
                  .searchPlaceByName(
                    this.hubName,
                    placeFromAI.place,
                    this.frontendSettings.ai.travelBuddy.cityName
                  )
                  .toPromise();
                console.log('---- place searched', placeSearched);
                placeInAnswer = placeSearched || {
                  name: placeFromAI.place,
                };
              }

              prePlans = [
                {
                  time: placeFromAI.time,
                  title: placeFromAI.activity,
                  type:
                    TripPlannerService.planTypes.find((x) => x.type === placeFromAI.activity)
                      ?.type || 'Custom',
                  content: placeFromAI.description,
                },
              ];

              currentDay.attractions.push({
                feedType: 'place',
                feedId: placeInAnswer?._id || placeInAnswer?.id,
                order: index++,
                searchedItem: placeInAnswer.hubName ? null : placeInAnswer, // place in the database has hubName, but searched from Google has not. For searched places, we save them in the trip collection in db (we only same place _id for those already in db)
                prePlans: prePlans,
                postPlans: [],
                item: !SocialLoginComponent.isUserLoggedIn ? placeInAnswer : undefined,
              });
            }

            days.push(currentDay);

            const addDay = this.timeService.addToDate(this.newDay, 'day', 1);
            this.newDay = addDay.toDate();
            console.log('newDay', this.newDay);
            this.editDayText = this.timeService.getOnlyDisplayDate(this.newDay);
          }
          console.log('days', days);

          saveTrip(days);
        }
      });
  }

  resetAITrip() {
    this.socketService.close();
    const msgBox = this.aiTripContentContainer?.nativeElement;
    msgBox && (msgBox.innerHTML = '');
    this.aiResTextContent = '';
    this.isAIGenerateCompleted = false;
    this.streamWordCount = 0;
    this.isAIThinking = false;
  }

  async createAITrip(tripType: string) {
    this.aiTripMenuTrigger?.closeMenu();

    // for mobile landing page
    if (this.displayingOn !== 'trip') {
      await this.goto('trip');
    }

    this.isAIThinking = true;
    this.isAIGenerateCompleted = false;

    this.socketService.init();
    setTimeout(() => {
      this.processSocketMsg();
    });

    this.visitorService
      .travelBuddyConversation({
        question: tripType, //`Please suggest a one-day ${tripType} itinerary in Savannah, GA`,
        hubName: this.hubName,
        userId: SocialLoginComponent.userId,
        userImg: SocialLoginComponent.profilePicture,
        socialName: SocialLoginComponent.socialName,
        userName: SocialLoginComponent.userName,
        cityName: this.frontendSettings.ai.travelBuddy.cityName,
        from: 'trip-planner',
      })
      .pipe(
        catchError((err) => {
          console.error(err);
          this.isAIThinking = false;
          this.socketService.close();
          return of({ success: false });
        })
      )
      .subscribe((response) => {
        console.log('subscribe askAI', response);
        if (!response.success) {
          this.isAIThinking = false;
          this.socketService.close();

          if (response.error) {
            const json = JSON.parse(response.error);
            alert(json.error.message);
          }
          return;
        }
      });
  }

  private processSocketMsg() {
    console.log('build socket msg...');
    this.socketService.socket.on('report', (report: { message; status; tag }) => {
      const userIdentity = `${SocialLoginComponent.userId}|${SocialLoginComponent.socialName}|${this.hubName}|trip-planner`;
      console.log('userIdentity', userIdentity);
      if (report.tag !== userIdentity) return;

      console.log('report received from socket: ', report);

      const msgBox = this.aiTripContentContainer.nativeElement;

      if (report.status === 'travelbuddy.message.start') {
        this.streamWordCount = 0;
        this.aiResTextContent = '';
        msgBox.innerHTML = '';
        // msgBox.classList.remove('loading-scale');
      }

      if (report.status === 'travelbuddy.message.delta') {
        this.streamWordCount++;
        this.aiResTextContent += report.message;
        msgBox.innerHTML = msgBox.innerHTML + report.message;

        // convert to HTML every 10 words
        if (this.streamWordCount % 10 === 0) {
          const marked = this.processMsg({ answer: this.aiResTextContent });
          msgBox.innerHTML = marked.answer;
        }

        // this.scrollToBottom(0);
      }

      // before loading mentioned places
      if (report.status === 'travelbuddy.message.completed') {
        // has <strong> in it means it mentioned places that need to be loaded and show images, then show the loading dot
        if (
          msgBox.innerHTML.toString().includes('<strong>') ||
          msgBox.innerHTML.toString().includes('<b>')
        ) {
          // msgBox.innerHTML += `<div class="flex flex-start"><div class="ig-loading-dot mt-3 !h-8 scale-[0.8]">
          //                     <div class="ig-loading-dot-wrap">
          //                       <div></div><div></div><div></div><div></div>
          //                     </div>
          //                   </div></div>`;
          // this.scrollToBottom(0);
          // this.isAIGenerateCompleted = true;
        }
      }

      if (report.status === 'travelbuddy.searching.internet') {
      }

      // when receiving this status, it means the AI has found places that need to be loaded, and this can be considered as a completed message
      if (report.status === 'travelbuddy.place.status') {
        // use SetTimeout to make sure other message content has been loaded
        setTimeout(() => {
          const placeStatus = JSON.parse(report.message);
          // msgBox.innerHTML = '';
          // msgBox.classList.remove('loading-scale');

          this.AIGeneratedTrip = {
            answer: this.aiResTextContent,
            placeStatus,
          };

          this.aiResTextContent = '';
          this.isAIGenerateCompleted = true;
          console.log('-------------- placeStatus --------------', placeStatus);
          // const processed = this.customProcessor({
          //   placeSearch: placeStatus.placeSearch,
          //   placesMentioned: placeStatus.placesMentioned,
          //   eventsMentioned: placeStatus.eventsMentioned,
          //   askForEvents: placeStatus.askForEvents,
          //   askForItinerary: placeStatus.askForItinerary,
          //   answer: this.processMsg({answer: this.aiResTextContent}).answer,
          // });

          // this.isAIThinking = false;
        }, 600);
      }

      this.cdRef.detectChanges();
    });
  }

  processMsg(response: { answer: string }): any {
    response.answer = window['marked'].parse(response.answer);

    response.answer = response.answer.replaceAll('####', '###');

    const pattern = /### (.+?)\n/g;

    const matches = response.answer.match(pattern);
    if (matches && matches.length) {
      for (const match of matches) {
        console.log(match);
        response.answer = response.answer.replace(match, match + '</h3>\n');
      }
    }

    // data.answer = data.answer.replace(/\s+/g, ' ');  // only keep single blank
    // data.answer = data.answer.replace(/<br>\s+<br>/g, '<br><br>');
    // data.answer = data.answer.replaceAll('<br>-', '<br><br>-');  // add a line break before each list item
    // data.answer = data.answer.replace(/<br>\d+\./g, '<br><br>$&');  // add a line break before each list item
    // data.answer = data.answer.replace(/(<br>)+/g, '<br><br>'); // replace multiple line breaks with a single one
    // data.answer = data.answer.replace(/<\/h3><br><br>/g, '</h3><br>'); // replace multiple line breaks with a single one after h3 title (which is usually "DAY 1" if you ask for an itinerary)
    // data.answer = data.answer.replace(/<br><br><\/h3>/g, '<br></h3>'); // replace multiple line breaks with a single one after h3 title (which is usually "DAY 1" if you ask for an itinerary)
    // data.answer = data.answer.replace(/&#39;/g, '\'');
    // data.answer = data.answer.replace(/&amp;/g, '&');
    // data.answer = data.answer.replace(/&quot;/g, '"');
    // data.answer = data.answer.replace(/\s<br><br>\s/g, '<br><br>');
    // data.answer = data.answer.replace(/<br><br> - /g, ' - ');
    // data.answer = data.answer.replace(/: -/g, ' -');
    // data.answer = data.answer.replace(/<br><br> <\/p>/g, '<br></p>');

    response.answer = response.answer
      .replace(/【.*?】/g, '')
      .replaceAll('###', '<h3>')
      .replaceAll('</h3><br></h3>', '</h3>')
      .replaceAll('</h3><br><br>', '</h3><br>')
      .replace(/(<h3>.*?<br>-)(?!<\/h3>)/g, '$1</h3>') // sometimes h3 doesn't have a closing tag, then add it
      .replaceAll('<br>-</h3>', '<br></h3>-')
      .replaceAll(' in the documents.', ' in my knowledge base.')
      .replaceAll(' in the uploaded documents.', ' in my knowledge base.')
      .replaceAll(' in the provided documentation.', ' in my knowledge base.')
      .replaceAll(' among the provided documentation.', ' in my knowledge base.')
      .replaceAll(' in the documentation.', ' in my knowledge base.')
      .replaceAll(' in the provided documents.', ' in my knowledge base.')
      .replaceAll(' within the provided documents.', ' in my knowledge base.')
      .replaceAll(' in the current documentation.', ' in my knowledge base.');

    try {
      // response.answer = JSON.parse(response.answer);
      // response.answer = window['marked']
      //   .parse(response.answer)
      //   .replace(/<\/?p>/g, '');

      // if (window['marked']) {
      //   response.answer = window['marked'].parse(response.answer);
      // } else {

      // for some version of iOS, the marked js cannot work, we parse the markdown here
      response.answer = response.answer.replaceAll('**', '*');
      const matches = response.answer.matchAll(/\*([^*]+)\*/g);

      for (const match of matches) {
        console.log('match[1]', match[1]);
        response.answer = response.answer.replaceAll(`*${match[1]}*`, `<b>${match[1]}</b>`);
      }

      console.log('replaced, ', response.answer);
      // }
    } catch (ex) {
      console.warn('parse error', ex.message);

      // if (window['marked']) {
      //   response.answer = window['marked'].parse(response.answer);
      // } else {
      //   // for some version of iOS, the marked js cannot work, we parse the markdown here
      //   response.answer = response.answer.replaceAll('**', '*');
      //   const matches = response.answer.matchAll(/\*([^*]+)\*/g);
      //
      //   for (const match of matches) {
      //     console.log('match[1]', match[1]);
      //     response.answer = response.answer.replaceAll(
      //       `*${match[1]}*`,
      //       `<em>${match[1]}</em>`
      //     );
      //   }
      //
      //   console.log('replaced, ', response.answer);
      // }
    }

    response.answer = response.answer.replaceAll('<a href=', '<a target="_blank" href=');

    return response;
  }

  getPlacesFromAIAnswer(data: { answer: string; placeSearch: any[]; placesMentioned: string[] }) {
    let placeNames = data.placesMentioned;
    if (!placeNames) return [];

    data.answer = data.answer.replace(/&#39;/g, "'"); // to escape the symbols so that can match the event/place names
    data.answer = data.answer.replace(/&amp;/g, '&');
    data.answer = data.answer.replace(/&quot;/g, '"');

    let places = [];

    for (let i = 0; i < placeNames.length; i++) {
      let place = data.placeSearch?.find((x) => similarity(x.name, placeNames[i]) > 0.8);
      if (place) {
        console.log(`************************* place found in placeSearch ${placeNames[i]}`, place);
        place = place.searchedPlace;
      } else {
        place = this.placesForAITripMatching.find((x) => x.name === placeNames[i]);
        console.log(`place find for ${placeNames[i]}`, place);
        if (!place) {
          let maxSimilarity = 0;
          let similarPlace = null;
          for (const p of this.places) {
            const nameSimilarity = similarity(p.name, placeNames[i]);
            if (nameSimilarity > maxSimilarity) {
              similarPlace = p;
              maxSimilarity = nameSimilarity;
            }
          }
          console.log('maxSimilarity', maxSimilarity);
          if (maxSimilarity >= 0.61) {
            place = similarPlace;
            console.log('similarPlace', place);
          } else {
            console.log('similarPlace -- ', similarPlace?.name);
          }
          console.log('\n');
        }
      }

      if (place && !places.any((x) => x._id === place._id)) {
        places.push(place);
      }
    }
    return places;
  }

  addDay() {
    console.log('newDay', this.newDay);
    this.currentTrip.days.push({
      date: this.newDay,
      dateText: this.timeService.getOnlyDisplayDate(this.newDay),
      note: '',
      attractions: [],
    });

    setTimeout(() => {
      this.newDay = null;
      this.daysTabGroup.selectedIndex = this.daysTabGroup._tabs.length - 1;
    });
  }

  dateFilter = (d: Date | null): boolean => {
    return !this.currentTrip.days.some(
      (day) => this.timeService.getOnlyDisplayDate(d) === day.dateText
    );
  };

  switchDays(index: number) {
    this.setMapMarkers(this.currentTrip.days[index]);
    this.setTripContainerHeight();
  }

  moveDayLeft(dayIndex: number) {
    if (dayIndex <= 0) return;

    const prev = this.currentTrip.days[dayIndex - 1];
    this.currentTrip.days[dayIndex - 1] = this.currentTrip.days[dayIndex];
    this.currentTrip.days[dayIndex] = prev;

    this.daysTabGroup.selectedIndex--;
  }

  moveDayRight(dayIndex: number) {
    if (dayIndex >= this.currentTrip.days.length - 1) return;

    const next = this.currentTrip.days[dayIndex + 1];
    this.currentTrip.days[dayIndex + 1] = this.currentTrip.days[dayIndex];
    this.currentTrip.days[dayIndex] = next;

    this.daysTabGroup.selectedIndex++;
  }

  addPlace(item, dayIndex: number) {
    console.log(item);

    if (this.currentTrip.days[dayIndex].attractions.some((x) => x.feedId === item._id)) {
      return;
    }

    if (!this.currentTrip.days || !this.currentTrip.days.length) {
      const newDate = new Date(new Date().getTime() + 7 * 24 * 60 * 60 * 1000);
      this.currentTrip.days = [
        {
          date: newDate,
          dateText: this.timeService.getOnlyDisplayDate(newDate),
          note: '',
          attractions: [],
        },
      ];
    }

    this.currentTrip.days[dayIndex].attractions.push({
      feedType: item.startTime ? 'event' : 'place',
      feedId: item._id,
      order: this.currentTrip.days[dayIndex].attractions.length,
      item,
    });

    this.setMapMarkers(this.currentTrip.days[dayIndex]);

    // if (SocialLoginComponent.isUserLoggedIn) {
    //   this.visitorService
    //     .addAttractionToTrip(this.hubName, {
    //       userFacebookId: SocialLoginComponent.userId,
    //       tripId: this.currentTrip.id,
    //       attraction: {
    //         feedType: item.startTime ? 'event' : 'place',
    //         feedId: item._id,
    //         order: this.currentTrip.days[dayIndex].attractions.length,
    //       },
    //     })
    //     .subscribe();
    // }
  }

  onAttractionDrop(event, day) {
    // swap pre and post plans
    const prePlansPrev = day.attractions[event.previousIndex].prePlans;
    const postPlansPrev = day.attractions[event.previousIndex].postPlans;
    const prePlansCurr = day.attractions[event.currentIndex].prePlans;
    const postPlansCurr = day.attractions[event.currentIndex].postPlans;

    day.attractions[event.previousIndex].prePlans = prePlansCurr;
    day.attractions[event.previousIndex].postPlans = postPlansCurr;

    day.attractions[event.currentIndex].prePlans = prePlansPrev;
    day.attractions[event.currentIndex].postPlans = postPlansPrev;

    moveItemInArray(day.attractions, event.previousIndex, event.currentIndex);

    this.setMapMarkers(day);
  }

  cancelEdit() {
    this.isEditMode = false;
    this.currentTrip = this.initTripBeforeEditing;
    this.setMapMarkers();
  }

  editOrSave(event: ButtonTriggerEvent) {
    this.isEditMode = !this.isEditMode;

    if (this.isEditMode) {
      this.initTripBeforeEditing = clone(this.currentTrip);
      this.titleForm.get('title').setValue(this.initTripBeforeEditing.title);
    }

    // save
    if (!this.isEditMode) {
      console.log('this.currentTrip', this.currentTrip);

      if (this.currentTrip.status === 'local') {
        try {
          let trips = this.loadLocalTrips();
          const index = trips.findIndex((t) => t.id === this.currentTrip.id);
          if (index >= 0) {
            trips[index] = this.currentTrip;
          }
          localStorage.setItem('localTrips', JSON.stringify(trips));
          event.success();
        } catch (e) {
          console.error('Error saving trip to localStorage', e);
          event.immediateComplete();
        }
      } else if (SocialLoginComponent.isUserLoggedIn) {
        this.visitorService
          .saveTrip(this.hubName, this.currentTrip, SocialLoginComponent.userId)
          .subscribe(() => {
            event.success();
          });
      }

      // else {
      //   try {
      //     let trips = this.loadLocalTrips();
      //     const index = trips.findIndex((t) => t.id === this.currentTrip.id);
      //     if (index >= 0) {
      //       trips[index] = this.currentTrip;
      //     }
      //     localStorage.setItem('localTrips', JSON.stringify(trips));
      //     event.success();
      //   } catch (e) {
      //     console.error('Error saving trip to localStorage', e);
      //     event.immediateComplete();
      //   }
      // }
    }

    this.setTripContainerHeight();
  }

  getTotalStops(trip: UserTrip) {
    let total = 0;
    for (const day of trip.days) {
      total += day.attractions.length;
    }
    return { total, text: `${total} stop${total > 1 ? 's' : ''}` };
  }

  getDisplayDate(date: Date | string) {
    return this.timeService.getOnlyDisplayDate(date);
  }

  getDeleteAttractionTip(day, attractionIndex) {
    return `Are you sure you want to remove this attraction from the itinerary? All the plans above ${
      attractionIndex === day.attractions.length - 1 ? 'and below' : ''
    } this attraction will be removed too.`;
  }

  deleteAttraction(day, attractionIndex: number) {
    this.rebuildPlanAssociation(day, attractionIndex);
    day.attractions.splice(attractionIndex, 1);
    this.isShowDeleteAttractionConfirms[attractionIndex] = false;

    this.setMapMarkers(day);
  }

  deleteTrip(trip: UserTrip) {
    if (trip.status === 'local') {
      this.deleteLocalTrip(trip);
      return;
    }

    if (SocialLoginComponent.userId) {
      this.isDeletingTrip = true;

      this.visitorService
        .deleteTrip(this.hubName, SocialLoginComponent.userId, trip.id)
        .pipe(
          finalize(() => {
            this.isDeletingTrip = false;
            this.closeConfirms();
          })
        )
        .subscribe(async () => {
          await this.loadTrips();
        });
    }
  }

  deleteLocalTrip(trip: UserTrip) {
    try {
      let trips = this.loadLocalTrips();
      const index = trips.findIndex((t) => t.id === trip.id);
      if (index >= 0) {
        trips.splice(index, 1);
      }
      localStorage.setItem('localTrips', JSON.stringify(trips));
      this.loadTrips();
    } catch (e) {
      console.error('Error deleting trip from localStorage', e);
    } finally {
      this.isDeletingTrip = false;
      this.closeConfirms();
    }
  }

  saveTripToDB(trip: UserTrip, callback?: () => void) {
    if (!SocialLoginComponent.isUserLoggedIn || trip.status === 'syncing') {
      return;
    }

    trip.status = 'syncing';

    this.visitorService.saveTrip(this.hubName, trip, SocialLoginComponent.userId).subscribe({
      next: () => {
        trip.status = 'synced';
        callback?.();

        setTimeout(() => {
          trip.status = 'cloud';

          this.deleteLocalTrip(trip);
          this.loadTrips();
        }, 3000);
      },
      error: () => {
        trip.status = 'local';
      },
    });
  }

  closeConfirms() {
    this.isShowDeleteTripConfirms = [];
  }

  deleteDay(dayIndex: number) {
    this.currentTrip.days.splice(dayIndex, 1);
    this.isShowDeleteDayConfirm = false;
  }

  getAvailableDates(day) {
    return this.currentTrip.days.filter((x) => x.dateText !== day.dateText);
  }

  editDateChange() {
    this.editDayText = this.timeService.getOnlyDisplayDate(this.newDay);
  }

  editDay(day, trigger: MatMenuTrigger) {
    console.log(day);
    console.log('this.newDay', this.newDay);
    if (this.newDay) {
      day.date = this.newDay;
      day.dateText = this.timeService.getOnlyDisplayDate(this.newDay);
    }

    this.newDay = null;
    this.editDayText = null;

    trigger.closeMenu();
  }

  editDayNote(day, trigger) {
    day.note = this.titleForm.get('note').value;
    trigger.closeMenu();
  }

  saveMoveDate(day, attractionIndex: number, trigger: MatMenuTrigger) {
    const targetDate = this.currentTrip.days.find((x) => x.dateText === this.moveToDate);
    console.log('targetDate', this.moveToDate);
    if (!targetDate) {
      console.log('no targetDate', this.moveToDate);
      return;
    }

    if (targetDate.attractions.length >= this.dayAttractionLimit) {
      this.snackBar.open(
        'You have reached the maximum number of attractions for that day!',
        'Close',
        {
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
          panelClass: 'ig-error-snackbar',
        }
      );
      return;
    }

    this.rebuildPlanAssociation(day, attractionIndex);

    const attraction = day.attractions[attractionIndex];
    // if the target day (move to this day)'s last attraction has post-plans, set them as the pre-plans of the moving attraction
    if (targetDate.attractions.length && targetDate.attractions.last().postPlans?.length) {
      attraction.prePlans = [...targetDate.attractions.last().postPlans];
      targetDate.attractions.last().postPlans = [];
    }

    targetDate.attractions.push(attraction);
    day.attractions.splice(attractionIndex, 1);

    this.setMapMarkers(day);
    this.setTripContainerHeight();

    trigger.closeMenu();
  }

  rebuildPlanAssociation(day, attractionIndex) {
    const attraction = day.attractions[attractionIndex];
    if (!attraction.prePlans) attraction.prePlans = [];
    if (!attraction.postPlans) attraction.postPlans = [];

    // process the moving attraction
    // not last attraction (which only has pre-plans), move its pre-plans to the below attraction
    if (attractionIndex !== day.attractions.length - 1 && attraction.prePlans.length) {
      day.attractions[attractionIndex + 1].prePlans = [
        ...attraction.prePlans,
        ...day.attractions[attractionIndex + 1].prePlans,
      ];
      attraction.prePlans = [];
    }

    // last attraction, move its pre/post-plans to the above attraction
    if (attractionIndex === day.attractions.length - 1 && day.attractions.length > 1) {
      if (!day.attractions[attractionIndex - 1].postPlans) {
        day.attractions[attractionIndex - 1].postPlans = [];
      }
      day.attractions[attractionIndex - 1].postPlans = [
        ...day.attractions[attractionIndex - 1].postPlans,
        ...attraction.prePlans,
        ...attraction.postPlans,
      ];
      attraction.prePlans = [];
      attraction.postPlans = [];
    }

    // Moving the only one attraction in the day will remove all the plans within this day.
    if (attractionIndex === day.attractions.length - 1 && day.attractions.length === 1) {
      attraction.prePlans = [];
      attraction.postPlans = [];
    }
  }

  setTripTitle(trigger: MatMenuTrigger) {
    this.currentTrip.title = this.titleForm.get('title').value;
    trigger.closeMenu();

    this.setTripContainerHeight();
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Tab') {
      event.stopPropagation();
    }
  }

  toggleSideBarOrCloseMap() {
    if (this.isShowingMapOnMobile) {
      this.isShowingMapOnMobile = false;
      this.selectedItemId = null;
    } else {
      this.toggleSidebar();
    }
  }

  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  acceptCookie() {
    this.isShowGDPR = false;
    localStorage.setItem(localStorageKeys.isGDPRShowed, 'true');
  }

  get getDisplayOn() {
    if (this.displayingOn === 'trip') {
      return 'My Trips';
    }
    if (this.displayingOn === 'itinerary') {
      return 'Suggested Itineraries';
    } else if (this.displayingOn === 'event') {
      return 'events to explore';
    } else if (this.displayingOn === 'place') {
      return 'places to visit';
    }
    return '';
  }

  addEventsManually() {
    this.modalService.show<CreateEventComponent>({
      component: CreateEventComponent,
      panelClass: 'ig-modal-w-full',
    });
  }

  addPlacesManually() {
    this.modalService.show<CreatePlaceComponent>({
      component: CreatePlaceComponent,
      panelClass: 'ig-modal-w-full',
    });
  }

  protected readonly SocialLoginComponent = SocialLoginComponent;
}

export type tripPlannerDisPlayingOn = 'event' | 'place' | 'itinerary' | 'trip';
